import * as yup from 'yup';

import {
  requiredConstant,
  emailRegex,
  emailValidConstant,
  urlRegex,
  urlValidConstant,
} from 'common/utils/constants';

export const CompanyDetailsSchema = yup.object().shape({
  founderDetails: yup.array().of(
    yup.object().shape({
      founderName: yup.string().required(requiredConstant),
      founderEmail: yup
        .string()
        .email(emailValidConstant)
        .required(requiredConstant)
        .matches(emailRegex, emailValidConstant),
    }),
  ),
  // founderName: yup.string().required(requiredConstant),
  // founderEmail: yup.string().email().required(requiredConstant),
  startupWebLink: yup
    .string()
    .nullable()
    .when({
      is: (value: string) => value.length > 0,
      then: yup.string().matches(urlRegex, urlValidConstant),
    }),
  businessOpsLocation: yup.object().nullable(),
  startupTwitterUrl: yup.string().nullable(),
  startupFacebookUrl: yup.string().nullable(),
  startupLinkedInUrl: yup.string().nullable(),
  productDescription: yup.string(),
  productProgress: yup.string(),
  potentialMarketTarget: yup.string(),
  startupInvestmentInformation: yup.string(),
  startupLegalInformation: yup.string(),
});

export const OtherInformationSchema = yup.object().shape({
  startup8vdxSource: yup.string().required(requiredConstant),
  startupReasonForChosing: yup.string().required(requiredConstant),
  startupInvestmentInformation: yup.string().required(requiredConstant),
  startupLegalInformation: yup.string().required(requiredConstant),
});

export const ApplyVDDebtSchema = yup.object().shape({
  startupFullName: yup.string().required(requiredConstant),
  assignedYcPartnerName: yup.string().required(requiredConstant).nullable(),
  assignedYcLegalPocName: yup.string().required(requiredConstant).nullable(),
  ycIncorporationCountry: yup.object().nullable().required(requiredConstant),
  stateOfIncorporation: yup
    .object()
    .nullable()
    .when('ycIncorporationCountry.countryCode', {
      is: 'PENDING_INCORPORATION',
      then: yup.object().nullable(),
      otherwise: yup.object().nullable().required(requiredConstant),
    }),
  startupTaxIdNumber: yup.string().nullable().required(requiredConstant),
  enquiryRequestLoanAmount: yup
    .number()
    .positive()
    .nullable(true)
    .required(requiredConstant)
    .transform((v, o) => (o === '' ? null : v))
    .min(50000, 'Please enter amount: Min 50K USD to Max 1000K USD')
    .test(
      'multiply',
      'Please enter amount in multiples of 1000s only',
      (value) => value !== undefined && value !== null && value % 1000 === 0,
    )
    .max(1000000, 'Please enter amount: Min 50K USD to Max 1000K USD'),
  industryType: yup.object().nullable().required(requiredConstant),
  industryClassification: yup.object().nullable().required(requiredConstant),
  enquiryTermsAccepted: yup.boolean().oneOf([true]).required(),
});

export const ApplyOtherVdDebtSchema = yup.object().shape({
  // startupYcAssignedId: yup.string().required(requiredConstant),
  startupFullName: yup.string().required(requiredConstant),
  ycIncorporationCountry: yup.object().nullable().required(requiredConstant),
  stateOfIncorporation: yup
    .object()
    .nullable()
    .when('ycIncorporationCountry.countryCode', {
      is: 'PENDING_INCORPORATION',
      then: yup.object().nullable(),
      otherwise: yup.object().nullable().required(requiredConstant),
    }),
  startupTaxIdNumber: yup.string().nullable().required(requiredConstant),
  enquiryRequestLoanAmount: yup
    .number()
    .positive()
    .nullable(true)
    .required(requiredConstant)
    .transform((v, o) => (o === '' ? null : v))
    .min(50000, 'Please enter amount: Min 50K USD to Max 1000K USD')
    .test(
      'multiply',
      'Please enter amount in multiples of 1000s only',
      (value) => value !== undefined && value !== null && value % 1000 === 0,
    )
    .max(1000000, 'Please enter amount: Min 50K USD to Max 1000K USD'),
  industryType: yup.object().nullable().required(requiredConstant),
  industryClassification: yup.object().nullable().required(requiredConstant),
  enquiryTermsAccepted: yup.boolean().oneOf([true]).required(),
});

export const QuerySchema = yup.object().shape({
  title: yup.string().required(requiredConstant),
  message: yup.string().required(requiredConstant),
});
